<template>
  <el-dialog
    :visible.sync="visible"
    width="1000px"
    @close="handleCancel"
    :title="title"
    :is-footer="false"
  >
    <div class="add-plan" style="height: 500px;">
      <div class="add-plan__form">
        <div class="form-item">
          <div class="item-label">计划名称</div>
          <div class="item-value">{{ planForm.planName }}</div>
        </div>
        <div class="form-item">
          <div class="item-label">频率</div>
          <div class="item-value">{{ dealrateType(planForm.rate) }}</div>
        </div>
        <div class="form-item">
          <div class="item-label">计划日期</div>
          <div class="item-value">{{ planForm.dates }}</div>
        </div>
        <div class="form-item">
          <div class="item-label">开始时间</div>
          <div class="item-value">{{ planForm.times }}</div>
        </div>
        <div class="form-item">
          <div class="item-label">持续时间</div>
          <div class="item-value">{{ planForm.duration }}</div>
        </div>
        <div class="form-item" style="width: 100%">
          <div class="item-label">执行人员</div>
          <div class="item-value">{{ planForm.peopleName }}</div>
        </div>
        <div class="form-item" style="width: 100%">
          <div class="item-label">备注</div>
          <div class="item-value">{{ planForm.remark }}</div>
        </div>
      </div>
      <div class="add-plan__info">
        <div class="info-content">
          <div class="info-content__opt" />
          <el-table :columns="tableColumns" :data="tableData">
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="deviceName"
              label="巡检设备"
              align="center"
            ></el-table-column>
            <el-table-column label="设备类型" align="center">
              <template slot-scope="scope">
                <span>{{ dealdeviceType(scope.row.deviceType) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="standardName"
              label="巡检标准"
              align="center"
            ></el-table-column>
            <template slot="empty">
            <div class="el-table__empty-block">
              <span class="el-table__empty-text">
                <div class="ioc-crud__empty">
                  <div class="ioc-empty">
                    <div class="ioc-empty__image" style="height: 50px">
                      <img src="../img/empty.svg" alt="" />
                    </div>
                    <p class="ioc-empty__desc">暂无数据</p>
                  </div>
                </div>
              </span>
            </div>
          </template>
          </el-table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import api from "../api/index";
export default {
  name: "viewPlanComponent",
  props: {
    title: {
      type: String,
      default: "巡更计划详情",
    },
    form: {
      type: Object,
      default: {},
    },
  },
  watch: {
    form: {
      handler(val) {
        const userName = []
        const userId = []
        if (val.users) {
          for (let i = 0; i < val.users.length; i++) {
            userName.push(val.users[i].username)
            userId.push(val.users[i].planUserUuid)
          }
        }
        if (val.planName) {
          this.planForm = {
            planName: val.planName || "",
            rate: val.planDateRate || "",
            dates:
              val.planDateRate == "0"
                ? [
                    this.formatDate(val.startDate),
                    this.formatDate(val.endDate),
                  ].join(",")
                : val.planDays,
            times: val.startTime || "",
            duration: val.duration || "",
            // peopleName: val.users.length ? val.users[0].username : "",
            // peopleId: val.users.length ? val.users[0].planUserUuid : "",
            peopleName: userName.length > 0 ? userName.join(',') : '',
            peopleId: userId.length > 0 ? userId.join(',') : '',
            remark: val.remark || "",
          };
          this.tableData = val.devices.map((item) => {
            return {
              deviceName: item.deviceName,
              deviceType: item.deviceTypeCode,
              deviceCode: item.deviceCode,
              standardName: item.standardName,
              standardId: item.standardId,
            };
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      rateList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "每天",
          value: "0",
        },
        {
          label: "自定义",
          value: "1",
        },
      ],
      deviceTypeList: [
        {
          label:'摄像机',
          value:'18'
        }
      ],
      multipleSelections: [],
      tableData: [],
      tableColumns: [
        {
          label: "序号",
          prop: "index",
        },
        {
          label: "巡检设备",
          prop: "deviceName",
        },
        {
          label: "设备类型",
          prop: "deviceType",
        },
        {
          label: "巡检标准",
          prop: "standardName",
        },
      ],
      visible: false,
      planForm: {
        planName: "",
        rate: "",
        dates: "",
        times: "",
        duration: "",
        peopleName: "",
        peopleId: "",
        remark: "",
      },
      gisVm: null,
      gisObj: null,
    };
  },
  mounted() {
    this.visible = true;
    this.queryDeviceType();
  },
  methods: {
    // 把设备类型转换成设备类型名字
    dealdeviceType(value) {
      let result = "";
      this.deviceTypeList.forEach((item) => {
        if (item.value == value) {
          result = item.label;
        }
      });
      return result;
    },
    // 转换频率
    dealrateType(value) {
      let result = "";
      this.rateList.forEach((item) => {
        if (item.value === value) {
          result = item.label;
        }
      });
      return result;
    },
    // 获取设备类型getDeviceType
    queryDeviceType() {
      this.$fetch(api.standard.getDeviceType).then((res) => {
        this.deviceTypeList = res.returnObj.map((item) => {
          return {
            label: item.deviceTypeName || "",
            value: item.deviceTypeId || "",
          };
        });
      });
    },
    handleCancel() {
      this.$emit("handleCancel");
    },
    // 日期格式化
    formatDate(param) {
      var date = null;
      date = new Date(param);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var strHours = date.getHours();
      var strMinutes = date.getMinutes();
      var strSeconds = date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (strHours >= 0 && strHours <= 9) {
        strHours = "0" + strHours;
      }
      if (strMinutes >= 0 && strMinutes <= 9) {
        strMinutes = "0" + strMinutes;
      }
      if (strSeconds >= 0 && strSeconds <= 9) {
        strSeconds = "0" + strSeconds;
      }
      var currentdate = year + "-" + month + "-" + strDate;
      return currentdate;
    },
  },
};
</script>

<style lang='scss' scoped>
.add-plan {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__form {
    display: flex;
    flex-wrap: wrap;

    .form-item {
      display: flex;
      align-items: center;
      width: 50%;
      margin-bottom: 20px;

      .item-label {
        margin-right: 10px;
      }
      .item-value {
      }
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0;

    .info-content {
      display: flex;
      flex-direction: column;
      margin-right: 20px;

      &__opt {
        margin-bottom: 15px;
        display: flex;

        .soc_button + .soc_button {
          margin-left: 10px;
        }
      }
    }
  }

  .operating {
    display: flex;
    align-items: center;

    .options_icon {
      cursor: pointer;
      margin-right: 10px;
    }

    .iconDelete {
      font-size: 12px;
    }
  }
}
</style>
